"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noop = exports.noop = function noop() {};
exports.default = noop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rmwc/Base/utils/noop.js
// module id = 36
// module chunks = 0